/**
 * ktg-quickview-variant-updater.js
 *
 * Fixes variant display updates (SKU, MSRP price) in quickview modals.
 * The main product page already updates these via product.liquid, but quickview
 * modals need this script to properly scope and update display elements within
 * the modal's drawer container when variants are changed.
 */
(function () {
  'use strict';
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail.variant;
    var container = event.target;

    if (!variant || !variant.sku) return;

    // Only run this in quickview modals - main product page already updates via product.liquid
    var parentContainer = container.closest('[data-quickview-modal]');
    if (!parentContainer) return;

    // Search within the drawer__content where the api-product-quickview content is injected
    var contentWrapper = parentContainer.querySelector('[data-product-quickview-ajax]');
    if (contentWrapper) {
      parentContainer = contentWrapper;
    }

    // Find the SKU element within the parent container
    var skuElement = parentContainer.querySelector('[data-product-sku]');
    if (skuElement) {
      skuElement.textContent = variant.sku;
    }

    // Update price element's data attribute
    var priceElement = parentContainer.querySelector('[data-product-price]');
    if (priceElement) {
      priceElement.setAttribute('data-product-id', variant.id);
    }

    // Update MSRP price
    var msrpElement = parentContainer.querySelector('.ktg-msrp-price');
    if (msrpElement && variant.price !== undefined) {
      var formattedPrice;
      if (window.themeCurrency && window.themeCurrency.formatMoney && window.theme) {
        var priceInCents = variant.price;
        var formattedValue = window.themeCurrency.formatMoney(priceInCents, window.theme.moneyFormat);

        if (window.theme.currencyCode) {
          formattedPrice = 'MSRP: ' + formattedValue + ' ' + window.theme.currencyCode;
        } else {
          formattedPrice = 'MSRP: ' + formattedValue;
        }
      } else {
        // Fallback if formatter not available
        formattedPrice = 'MSRP: $' + (variant.price / 100).toFixed(2);
      }
      msrpElement.textContent = formattedPrice;
    }
  });
})();
